import { useEffect, useState } from 'react';
import { SectionHeader } from '@/shared/components/export';
import { ContrastingColors, ThemeValues, themeService } from '@/shared/theme/export';
import { localPreferencesService } from '@/core/preferences/export';
import SettingsSelectField from '@/core/settings/components/settings-select-field';

export default function AppearanceTab() {
  const [contrastingColors, setContrastingColors] = useState<ContrastingColors>('orange-blue');
  const [theme, setTheme] = useState<ThemeValues>('dark');
  const [showFlags, setShowFlags] = useState<boolean>(true);

  useEffect(() => {
    localPreferencesService.getLocalPreferences().then(value => {
      if (value.contrastingColors) setContrastingColors(value.contrastingColors);
      if (value.theme) setTheme(value.theme);
      if (value.showFlags || value.showFlags === false) setShowFlags(value.showFlags);
    });
  }, []);

  const onColorSelect = (value: ContrastingColors) => {
    localPreferencesService
      .updateLocalPreferences(async localPreferences => {
        localPreferences.contrastingColors = value;

        return localPreferences;
      })
      .then(localPreferences => {
        setContrastingColors(value);
        themeService.setThemeBasedOnUserPreferences(localPreferences);
      });
  };

  const onThemeSelect = (value: ThemeValues) => {
    localPreferencesService
      .updateLocalPreferences(async localPreferences => {
        localPreferences.theme = value;

        return localPreferences;
      })
      .then(localPreferences => {
        setTheme(value);
        themeService.setThemeBasedOnUserPreferences(localPreferences);
      });
  };

  const onShowFlagsSelect = (value: boolean) => {
    localPreferencesService
      .updateLocalPreferences(async localPreferences => {
        localPreferences.showFlags = value;

        return localPreferences;
      })
      .then(localPreferences => {
        setShowFlags(value);
        themeService.setThemeBasedOnUserPreferences(localPreferences);
      });
  };

  return (
    <div style={{ flex: '1 1 auto', paddingRight: 24 }}>
      <SectionHeader title="Appearance" />

      <SettingsSelectField
        label="Theme"
        value={theme}
        onChange={event => onThemeSelect(event.target.value as ThemeValues)}
        helpText="Application theme."
      >
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </SettingsSelectField>

      <SettingsSelectField
        label="Contrasting Colors"
        value={contrastingColors}
        onChange={event => onColorSelect(event.target.value as ContrastingColors)}
        helpText="Colors for calculated differences."
      >
        <option value="orange-blue">Orange / Blue</option>
        <option value="red-green">Red / Green</option>
        <option value="yellow-purple">Yellow / Purple</option>
      </SettingsSelectField>

      <SettingsSelectField
        label="Show Flags"
        value={`${showFlags}`}
        onChange={event => onShowFlagsSelect(event.target.value === 'true')}
        helpText="Whether to show flags or just country names."
      >
        <option value="true">Yes, show flag images</option>
        <option value="false">No, just show country abbreviation</option>
      </SettingsSelectField>
    </div>
  );
}
